import React from "react";
import Container from "./Components/Container/Container";


function App() {
  return (
    <div>
      <Container></Container>
    </div>
  );
}

export default App;
